import { Component, OnInit, OnDestroy } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { IdentityService } from '../../identity.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { confirmPasswordValidator } from 'src/app/shared/validators/confirm-password.validator';
import { Router } from '@angular/router';
import { UIControlService } from 'src/app/shared/uicontrol.service';

@Component({
  selector: 'app-email-signup',
  templateUrl: './email-signup.component.html',
  styleUrls: ['./email-signup.component.scss']
})
export class EmailSignupComponent implements OnInit, OnDestroy {
  constructor(
    public identityService: IdentityService,
    private formBuilder: FormBuilder,
    private ui: UIControlService,
    private router: Router
  ) {}

  public form: FormGroup;
  public destroyed = new Subject();
  public loading = false;

  public ngOnInit(): void {
    this.form = this.formBuilder.group({
      displayName: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      passwordConfirm: ['', [Validators.required, confirmPasswordValidator]]
    });

    this.form.controls.password.valueChanges
      .pipe(takeUntil(this.destroyed))
      .subscribe(() => {
        this.form.controls.passwordConfirm.updateValueAndValidity();
      });
  }

  public async signUp() {
    if (this.form.valid) {
      this.loading = true;
      this.identityService
        .signUpWithEmailAndPassword(
          this.form.value.displayName.toString().trim(),
          this.form.value.email.toString().trim(),
          this.form.value.password.toString().trim()
        )
        .subscribe(
          () => {
            this.identityService.handleAuthenticationReroute();
          },
          error => {
            console.error(error);
            this.ui.notifyFailure('Registration failed.');
          },
          () => {
            this.loading = false;
          }
        );
    } else {
      this.ui.notifyFailure('Please correct your details.');
    }
  }

  public ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
